// libraries
import get from "lodash.get";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
// @ts-ignore
import { useHistory } from "react-router";
// services
import Loading from "../../../components/loaders/buttonLoader/index";
import { HoverStyle } from "../../../components/print/paymentCheck/style";
import { api } from "../../../services/api/api";
import { BaseResponse } from "../../../services/api/response/BaseResponse";
import browserStorage from "../../../services/storage";
import { LanguageStyle, RoundedButton } from "../../navigator/header.style";
import { language } from "../../navigator/navigator.constants";
import {
  FormRight,
  InputContent,
  NumberInputStyled,
  PasswordStyle,
} from "../Components/style";
import { useRequest } from "./../../../hooks/useRequest/UseRequest";
import { REQUEST_STATUS } from "./../../../hooks/useRequest/useRequest.constants";
// assets
import "react-phone-number-input/style.css";
import { useTheme } from "styled-components";
import { baseErrors } from "../../../assets/errors/baseErrors";
import E from "../../../assets/images/icons/E";
import EyeOff from "../../../assets/images/icons/EyeOff";
import EyeOn from "../../../assets/images/icons/EyeOn";
import LogoTitle from "../../../assets/images/icons/LogoTitle";
import RussianFlag from "../../../assets/images/icons/RussianFlag";
import UnitedStates from "../../../assets/images/icons/unitedStates";
import UzbekistanFlag from "../../../assets/images/icons/UzbekistanFlag";
import { StyledButton } from "../../../assets/styles/Button";
import { IconButton } from "@material-ui/core";
import LoginIcon from "../../../assets/images/icons/LoginIcon";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const PHONE_NUMBER_PATTERN =
  "/^(+{0,})(d{0,})([(]{1}d{1,3}[)]{0,}){0,}(s?d+|+d{2,3}s{1}d+|d+){1}[s|-]?d+([s|-]?d+){1,2}(s){0,}$/gm";

const SignInWithPassword = () => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const [number, setNumber] = useState<any>(
    // @ts-ignore
    browserStorage.get("phoneNumber") || "+998"
  );

  const [passwordInputType, setPasswordInputType] = useState<
    "password" | "text"
  >("password");
  const theme: any = useTheme();
  const [hasPassword, setHasPassword] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const [signInClient, signInData, signInStatus] = useRequest();
  const [signVerifyClient, signVerifyData, signVerifyStatus] = useRequest();

  // useEffect(() => {
  //   if (resultPhoneNumber()?.length === 13) {
  //     signInClient.post("sign-in", { phoneNumber: resultPhoneNumber() });
  //   } else {
  //     setHasPassword(false);
  //   }
  // }, [number]);

  const signInSubmit = () => {
    if (true) {
      // :(
      signInClient.post("sign-in", { phoneNumber: resultPhoneNumber() });
    } else {
      setHasPassword(false);
    }
  };

  useEffect(() => {
    if (signInStatus === REQUEST_STATUS.success) {
      browserStorage.set("phoneNumber", resultPhoneNumber());
      if (get(signInData, "data.hasPassword") === false) {
        toast.success("Bir martalik kodni kiriting!");
      }
      setHasPassword(get(signInData, "data.hasPassword"));
    }
  }, [signInStatus]);
  useEffect(() => {
    if (signVerifyStatus === REQUEST_STATUS.success) {
      const token = get(signVerifyData, "data.token", "");
      const branch = get(signVerifyData, "data.branches[0]._id", "");
      const phoneNumber = get(signVerifyData, "data.phoneNumber", "");
      const branchList = get(signVerifyData, "branches?.data", "");
      if (token) browserStorage.set("token", token);
      if (branch) browserStorage.set("branch", branch);
      if (phoneNumber) browserStorage.set("phoneNumber", phoneNumber);
      if (branchList) browserStorage.set("branchList", branchList);
      history.push("password");
      toast.success(signVerifyData.message);
    } else if (signVerifyStatus === REQUEST_STATUS.failed) {
      // history.push("password");
    }
  }, [signVerifyStatus]);

  const resultPhoneNumber = (): string => {
    return number;
  };
  const submit = async (object: any) => {
    if (hasPassword) {
      try {
        const { data } = await api.apiCall<BaseResponse<any>>(
          "/sign-with-password",
          {
            // phoneNumber: browserStorage.get("phoneNumber"),
            phoneNumber: resultPhoneNumber(),
            password: object.password,
          }
        );
        if (data) toast.success(t(`TOAST_MESSAGES.${baseErrors[data?.code]}`));
        const token = await get(data, "data.token", "");
        const branch = await get(data, "data.branches[0]._id", "");
        const phoneNumber = await get(data, "data.phoneNumber", "");
        const branchList = await get(data, "data.branches", "");
        if (branchList) browserStorage.set("branchList", branchList);
        if (token) browserStorage.set("token", token);
        if (branch) browserStorage.set("branch", branch);
        if (phoneNumber) browserStorage.set("phoneNumber", phoneNumber);
        let currentPath: string | undefined = browserStorage.get("currentPath");
        browserStorage.remove("currentPath");
        history.push(currentPath || "/home"); // ! i will change this billing
      } catch (e: any) {
        if (e?.response?.data?.code === 401) {
          localStorage.clear();
          history.push("/");
        }
        toast.error(t(`TOAST_MESSAGES.${baseErrors[e?.response?.data?.code]}`));
      } finally {
      }
    } else if (!hasPassword) {
      signVerifyClient.post("sign-verify", {
        phoneNumber: browserStorage.get("phoneNumber"),
        otp: object.otp,
      });
    }
  };
  const forget = async () => {
    history.push("/forget-password");
  };
  const eyeIconClick = () => {
    if (passwordInputType === "password") setPasswordInputType("text");
    if (passwordInputType === "text") setPasswordInputType("password");
  };

  const lang = browserStorage.get("i18nextLng");

  return (
    <>
      <FormRight>
        <div className="mx-auto w-75 h-100">
          <div className="d-flex justify-content-between pt-4">
            <div className="d-flex align-items-center">
              <E />
              <div
                className="h-75 mx-2"
                style={{
                  border: `0.2px solid ${theme.black.dark}`,
                  opacity: "0.1",
                }}
              />
              <div>
                <LogoTitle />
                <p className="mb-0">{t("LOGIN_PAGE.SLOGAN")}</p>
              </div>
            </div>
            <div>
              <LanguageStyle
                isSearchable={false}
                onChange={(e: any) => {
                  i18n.changeLanguage(e.value);
                }}
                className={"mx-3"}
                classNamePrefix="react-select"
                value={
                  lang
                    ? language.map((item: any) => {
                        if (item.value === browserStorage.get("i18nextLng")) {
                          return {
                            ...item,
                            label:
                              item.value === "uz" ? (
                                <UzbekistanFlag style={{ cursor: "pointer" }} />
                              ) : item.value === "ru" ? (
                                <RussianFlag style={{ cursor: "pointer" }} />
                              ) : (
                                <UnitedStates style={{ cursor: "pointer" }} />
                              ),
                          };
                        }
                      })
                    : {
                        value: "uz",
                        label: <UzbekistanFlag style={{ cursor: "pointer" }} />,
                      }
                }
                options={language.map((lang: any) => {
                  return {
                    ...lang,
                    label:
                      lang.value === "uz" ? (
                        <UzbekistanFlag style={{ cursor: "pointer" }} />
                      ) : lang.value === "ru" ? (
                        <RussianFlag style={{ cursor: "pointer" }} />
                      ) : (
                        <UnitedStates style={{ cursor: "pointer" }} />
                      ),
                  };
                })}
                menuPlacement="bottom"
              />
            </div>
          </div>
          <form
            id="login-form"
            onSubmit={handleSubmit(submit)}
            className="main-form"
          >
            <h3 className="text-center mb-4">{t("LOGIN_PAGE.LOGIN")}</h3>
            <>
              <form
                id="sign-in-form"
                onSubmitCapture={(e) => {
                  e.preventDefault();
                  signInSubmit();
                }}
              >
                <div className="sign-in-div">
                  <NumberInputStyled
                    placeholder={t("LOGIN_PAGE.PHONE_NUMBER_ENTER")}
                    autoFocus
                    value={number}
                    onChange={(e: any) => {
                      setNumber(e);
                      setHasPassword(false);
                    }}
                    maxLength={17}
                  />
                </div>
              </form>
              {/* <PhoneNumberStyled
                maxLength={17} // +998 99 655 1401
                // defaultCountry="UZ"
                value={number}
                onChange={(e: any) => {
                  setNumber(e);
                }}
              /> */}
            </>
            {hasPassword && (
              <>
                <label
                  htmlFor="exampleInputPassword"
                  className="form-label mt-3"
                >
                  {t("LOGIN_PAGE.PASSWORD")}
                </label>
                <InputContent>
                  <PasswordStyle
                    autoFocus
                    type={passwordInputType}
                    autocomplete="off"
                    className="form-control"
                    id="exampleInputPassword"
                    required={hasPassword && true}
                    disabled={!hasPassword}
                    {...register("password", { required: true })}
                  />
                  <div className="eye-icon">
                    <HoverStyle className="hover-style" onClick={eyeIconClick}>
                      {passwordInputType === "password" ? (
                        // <EyeOff width="15px" height="15px" />
                        <VisibilityOff/>
                      ) : (
                        // <EyeOn width="15px" height="15px" />
                        <Visibility/>

                      )}
                    </HoverStyle>
                  </div>
                </InputContent>
                <div className="text-end mb-0 mt-2">
                  <button
                    onClick={forget}
                    type="button"
                    disabled={!hasPassword}
                    className={`edit-password ${hasPassword && "text-primary"}`}
                  >
                    {t("LOGIN_PAGE.FORGET_PASSWORD")}
                  </button>
                </div>
              </>
            )}
            {signInData?.data?.hasPassword === false &&
              !hasPassword &&
              resultPhoneNumber()?.length === 13 && (
                <>
                  {/* <p className="mb-0">{phone || ""}</p> */}
                  <label
                    htmlFor="exampleInputPassword"
                    className="form-label mt-3"
                  >
                    {t("LOGIN_PAGE.OTP")}
                  </label>
                  <PasswordStyle
                    autocomplete="off"
                    type="number"
                    className="form-control"
                    id="exampleInputPassword"
                    autoFocus
                    required={true}
                    {...register("otp", {
                      required: true,
                    })}
                  />
                </>
              )}
            <StyledButton
              type="submit"
              form={
                signInStatus === REQUEST_STATUS.success
                  ? "login-form"
                  : "sign-in-form"
              }
              className="btn-block btn btn-primary w-100 mt-4"
              // disabled={!(signInStatus === REQUEST_STATUS.success)}
            >
              {signInStatus === REQUEST_STATUS.success
                ? t("LOGIN_PAGE.LOGIN")
                : t("GENERAL.approve")}
              <Loading
                hasDisabled={
                  signInStatus === REQUEST_STATUS.loading ||
                  signVerifyStatus === REQUEST_STATUS.loading
                }
              />
            </StyledButton>
          </form>
        </div>
      </FormRight>
    </>
  );
};

export default SignInWithPassword;
